import React from 'react'
import { MetBeforeContact, useMetBefore } from 'src/pages/quiz/components/MetBefore/MetBefore.hook'
import 'src/pages/quiz/components/MetBefore/style.scss'
import closeIcon from 'src/assets/images/cannyValley/close.svg'

import './style.scss'

interface MetBeforeModalProps {
  isOpen: boolean
  onClose: () => void
  classes?: string
  contact: MetBeforeContact
}

const MetBeforeModal = (props: MetBeforeModalProps) => {
  const { isOpen, onClose, classes, contact } = props
  const { handleNext, reason, handleSelectedReason, additionalNotes, setAdditionalNotes, nextDisabled } = useMetBefore(
    contact
  )
  if (!isOpen) return <></>

  return (
    <div className={`modal-overlay ${classes}`}>
      <div className="modal-content met-before">
        <button className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
        <div className="met-before-wrapper">
          <div>
            <h2 className="title">Hey, we’ve met before</h2>
            <p className="description">
              We already have your email or phone number in our system. Good to see you back!
            </p>
            <div className="reason-group mt-15px">
              {reason.map((r) => (
                <div
                  key={r.id}
                  className={`card ${r.isSelected ? 'active' : ''}`}
                  onClick={() => handleSelectedReason(r.id)}
                >
                  <span className="reason-text">{r.label}</span>
                </div>
              ))}
            </div>
            <div className="mt-30px">
              <div className="floating-label-wrapper">
                <input
                  id="reasonNoteId"
                  className="input w-100"
                  value={additionalNotes}
                  type="text"
                  name="reasonNote"
                  placeholder="Additional notes (optional)"
                  onChange={(e) => setAdditionalNotes(e.target.value)}
                />
              </div>
            </div>
            <div className="action-box-wrapper mt-30px mb-90px">
              <button disabled={nextDisabled} className="button white-space-wrap" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MetBeforeModal
